<template>
  <div class="vld-parent">
    <Loading
      :active.sync="ATIVAR_CARREGAMENTO_COMPUTED"
      :can-cancel="false"
      :is-full-page="true"
      color="#042333"
      :width="150"
      :height="150"
      :enforce-focus="false"
      loader="bars"
    />
  </div>
</template>

<script setup>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {computed} from "vue";
import store from "@/store";

const QTDE_REQUISICOES_COMPUTED = computed(() => Number(store.getters['loading/qtde_requisicoes']));
const ATIVAR_CARREGAMENTO_COMPUTED = computed(() => QTDE_REQUISICOES_COMPUTED.value > 0);
</script>
